function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.148 4.573H5.508L4.722 1.23C4.656.77 4.262.508 3.869.508H.92c-1.247 0-1.247 1.77 0 1.77h2.229l2.885 12.263a.926.926 0 00.918.655h13.967a.926.926 0 00.918-.655L24 5.688c.131-.524-.328-1.115-.852-1.115zm-2.951 8.853H7.672L5.967 6.409h16l-1.77 7.017zM8.656 16.508A2.49 2.49 0 006.164 19a2.49 2.49 0 002.492 2.491 2.49 2.49 0 100-4.984zm0 3.475A.966.966 0 017.672 19c0-.525.394-.984.984-.984.524 0 .983.46.983.984s-.459.983-.983.983zM16.459 19a2.49 2.49 0 114.984 0 2.49 2.49 0 01-2.492 2.491A2.49 2.49 0 0116.46 19zm1.509 0c0 .524.459.983.983.983.525 0 .984-.459.984-.983 0-.525-.46-.984-.984-.984s-.983.46-.983.984z",
  fill: "#183558"
});

var SvgCart = function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none"
  }, props), _ref);
};

export default SvgCart;